import { createParser } from 'nuqs';

/**
 * Encode object into compressed query param (base64 + URI safe)
 * @param {Record<string, any>} obj 
 * @returns {string} - URL of the success page.
 */
export const encodeParams = (obj) => {
  const json = JSON.stringify(obj);
  return btoa(encodeURIComponent(json));
}

/**
 * Decode compressed query param back into object
 * @param {string} encoded 
 * @returns {Record<string, any> | null} - Decoded object or null if decoding fails.
 */
export const decodeParams = (encoded) => {
  try {
    const json = decodeURIComponent(atob(encoded));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/**
 * nuqs parser for compressed params
 */
export const parseAsCompressed = createParser({
  parse(queryValue) {
    return decodeParams(queryValue);
  },
  serialize(value) {
    return encodeParams(value);
  },
});
